import SvgIcon from '@carrier-io/air-react/SvgIcon';

const NextArrow = () => {
  return (
    <SvgIcon>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" fill="white" />
      </svg>
    </SvgIcon>
  );
};

export default NextArrow;
